@if (tournament) {
  <div class="tournament">
    <div class="tournament__info">
      @if (tournament?.Vip || tournament?.isGroupTournament) {
        <div class="tournament__badges">
          @if (tournament?.Vip) {
            <div class="tournament__badges_vip">{{ 't.vip' | translate }}</div>
          }
          @if (tournament?.isGroupTournament) {
            <div class="tournament__badges_group">{{ 't.group-tournament' | translate }}</div>
          }
        </div>
      }

      <div class="tournament__title" [innerHTML]="tournament?.Title | safe: 'html'"></div>
      <div class="tournament__prize" [innerHTML]="tournament?.Prize | safe: 'html'" [ngClass]="{'text-gradient': rtl.isAr}"></div>
      <div class="tournament__second-prize" [innerHTML]="tournament?.SecondPrize | safe: 'html'" [ngClass]="{'text-gradient': rtl.isAr}"></div>
      <div class="tournament__timer mobile">
        @if (tournament?.activeMultiTournament?.end_at || tournament?.unpublishAt?.date) {
          <app-timer
            [tournament]="tournament"
            [timeLeft]="tournament?.activeMultiTournament?.end_at || tournament?.unpublishAt?.date">
          </app-timer>
        }
      </div>
      @if (tournament?.gameListPreview?.[0]?.length) {
        <div class="tournament__games">
          @for (game of tournament?.gameListPreview?.[0]; track game) {
            <app-game-preview [game]="game" [isTournamentPreview]="true"></app-game-preview>
          }
        </div>
      }
      <div class="tournament__more-details desktop">
        <div class="tournament__actions-info">
          @if (user.auth) {
            @if (tournament?.userStatus$ | async; as status) {
              @if (status?.bet_cents) {
                <div class="tournament__actions-info--details"
                     [routerLink]="!tournament.isGroupTournament ? ['/', 'tournaments', tournament?.slug] : ['/', 'tournaments', 'group', tournament?.slug]">
                  {{ 't.details' | translate }}
                </div>
              } @else {
                <button class="btn btn--filled-primary"
                        (click)="onGetBonusClick()"
                        [state]="tournament"
                        [routerLink]="!tournament.isGroupTournament ? ['/', 'tournaments', tournament?.slug] : ['/', 'tournaments', 'group', tournament?.slug]">
                  {{'t.take-part' | translate}}
                </button>
              }
            } @else {
              <button class="btn btn--filled-primary"
                      (click)="onGetBonusClick()"
                      [state]="tournament"
                      [routerLink]="!tournament.isGroupTournament ? ['/', 'tournaments', tournament?.slug] : ['/', 'tournaments', 'group', tournament?.slug]">
                {{'t.take-part' | translate}}
              </button>
            }
          } @else {
            @if (!tournament.isGroupTournament) {
              <button class="btn btn--filled-primary"
                      (click)="onGetBonusClick()"
                      [queryParams]="{modal: !user.isUserAlreadyRegistered ? 'registration' : 'login'}"
                      routerLink="./">
                {{'t.take-part' | translate}}
              </button>
            } @else {
              <button class="btn btn--filled-primary"
                      (click)="onGetBonusClick()"
                      [state]="tournament"
                      [routerLink]="['/', 'tournaments', 'group', tournament?.slug]">
                {{'t.take-part' | translate}}
              </button>
            }
          }

          @if (tournament?.activeMultiTournament?.end_at || tournament?.unpublishAt?.date) {
            <app-timer class="desktop"
                       [tournament]="tournament"
                       [timeLeft]="tournament?.activeMultiTournament?.end_at || tournament?.unpublishAt?.date">
            </app-timer>
          }

          @if (tournament?.strategy$ | async; as strategy) {
            <div class="tournament__actions-info--bets">
              @switch (true) {
                @case (strategy === tournamentStrategyBet) {
                  <div>
                    <img src="/assets/img/tournaments/icon-bets.svg" alt="">
                    <span>{{ 't.betting-based' | translate }}</span>
                  </div>
                }
                @case (strategy === tournamentStrategyWin) {
                  <div>
                    <img src="/assets/img/tournaments/icon-win.svg" alt="">
                    <span>{{ 't.winning-based' | translate }}</span>
                  </div>
                }
              }

              @if (tournament?.MinBet) {
                <div>
                  <span [innerHTML]="tournament?.MinBet"></span>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="tournament__more-details mobile">
        @if (tournament?.strategy$ | async; as strategy) {
          <div class="tournament__actions-info--bets">
            @switch (true) {
              @case (strategy === tournamentStrategyBet) {
                <div>
                  <img src="/assets/img/tournaments/icon-bets.svg" alt="">
                  <span>{{ 't.betting-based' | translate }}</span>
                </div>
              }
              @case (strategy === tournamentStrategyWin) {
                <div>
                  <img src="/assets/img/tournaments/icon-win.svg" alt="">
                  <span>{{ 't.winning-based' | translate }}</span>
                </div>
              }
            }

            @if (tournament?.MinBet) {
              <div>
                <span [innerHTML]="tournament?.MinBet"></span>
              </div>
            }
          </div>
        }

        @if (user.auth) {
          @if (tournament?.userStatus$ | async; as status) {
            @if (status?.bet_cents) {
              <div class="tournament__actions-info--details"
                   [routerLink]="!tournament.isGroupTournament ? ['/', 'tournaments', tournament?.slug] : ['/', 'tournaments', 'group', tournament?.slug]">
                {{ 't.details' | translate }}
              </div>
            } @else {
              <button class="btn btn--filled-primary"
                      (click)="onGetBonusClick()"
                      [state]="tournament"
                      [routerLink]="!tournament.isGroupTournament ? ['/', 'tournaments', tournament?.slug] : ['/', 'tournaments', 'group', tournament?.slug]">
                {{'t.take-part' | translate}}
              </button>
            }
          } @else {
            <button class="btn btn--filled-primary"
                    (click)="onGetBonusClick()"
                    [state]="tournament"
                    [routerLink]="!tournament.isGroupTournament ? ['/', 'tournaments', tournament?.slug] : ['/', 'tournaments', 'group', tournament?.slug]">
              {{'t.take-part' | translate}}
            </button>
          }
        } @else {
          @if (!tournament.isGroupTournament) {
            <button class="btn btn--filled-primary"
                    (click)="onGetBonusClick()"
                    [queryParams]="{modal: !user.isUserAlreadyRegistered ? 'registration' : 'login'}"
                    routerLink="./">
              {{'t.take-part' | translate}}
            </button>
          } @else {
            <button class="btn btn--filled-primary"
                    (click)="onGetBonusClick()"
                    [state]="tournament"
                    [routerLink]="['/', 'tournaments', 'group', tournament?.slug]">
              {{'t.take-part' | translate}}
            </button>
          }
        }
      </div>
    </div>

    <img [src]="tournament?.ImageList || tournament?.ImageNew" [alt]="tournament?.Title" class="tournament__img">
  </div>
}
